import ptLocale from "element-ui/lib/locale/lang/pt";
const pt = {
  //葡萄牙语 Portuguese
  login: {
    buttoo: {
      add: "add",
    },
  },
  dialog: {
    buttton: {
      close: "Perto",
    },
    ReportError: {
      next: "próximo",
      h1: "Reportar erros permite que os utilizadores comuniquem connosco para resolver quaisquer problemas de dados e melhorar a qualidade dos dados.",
      li1: "Se encontrar algum problema de dados ou tiver alguma dúvida sobre esses dados",
      li2: "Se pretende contribuir com informações da empresa para melhorar estes dados",
      li3: "Se optar por não divulgar informações da sua própria empresa que possa considerar privadas",
      li4: "Se tiver alguma sugestão construtiva para melhorarmos os serviços",
      h2: "Todos os comentários submetidos estão sujeitos a verificação de dados. Os utilizadores devem preencher o seu próprio perfil de utilizador, uma vez que o nosso representante poderá contactá-lo para autenticação e verificação de quaisquer direitos da sua empresa para a representar.",
      Iamanemployeeofthissubjectcompany: "Sou funcionário desta empresa",
      Reportmycompany: "Denunciar a minha empresa",
      Updatedata: "Atualizar dados",
      Reportinformationerrors: "Informações do relatório de erros",
      Reportotherscompany: "Denunciar outras empresas",
      Financial: "Financeira",
      Pleaseprovidemoreinfo: "Por favor, forneça mais informações.",
      Year: "Ano",
      Business: "Negócio",
      Noofemployees: "Número de colaboradores",
      Coremanagement: "Gestão central",
      Corebusinessactivites: "Atividades principais do negócio",
      IntBusiness: "Negócios Internacionais",
      Pleasedescribeyouractivites: "Por favor, descreva as suas atividades.",
      Pleaselistcountriesyoudobusine:
        "Por favor, liste os países onde faz negócios.",
      Corecompetency: "Competência essencial",
      Businessoutlook: "Perspectivas de negócio",
      Uploadfiles: "Carregar ficheiros",
      Upload: "Carregar",
      Cancel: "Cancelar",
      Submit: "Submeter",
      Select: "Selecionar",
      Selectthedatacategoryyoureport:
        "Selecione a categoria de dados que está a reportar.",
      TotalCurrentAssets: "Total de ativos correntes",
      CashBank: "Dinheiro e Banco",
      Accountreceivable: "Contas a receber",
      AdvancestoSuppliers: "Adiantamentos para fornecedores",
      Inventory: "Inventário",
      Tobeappointedexpense: "Despesas a designar",
      Totalnoncurrentassets: "Total de ativos não correntes",
      Longterminvestment: "Investimento de longo prazo",
      Fixedassetsnetvalue: "valor líquido dos ativos fixos",
      Projectsunderconstruction: "Projetos em construção",
      Longtermtobeappointedexpenise: "Despesa a atribuir a longo prazo",
      Deferredtaxdebit: "Débito de imposto diferido",
      Totalcurrentliabilities: "Passivo circulante total",
      Accountpayable: "Conta a pagar",
      Advancesfromclients: "Adiantamentos dos clientes",
      Salariespayable: "Salários a pagar",
      Taxespayable: "Impostos a pagar",
      Otheraccountspayable: "Outras contas a pagar",
      Totalequity: "Patrimônio líquido total",
      Paidupcapital: "Capital integralizado",
      Capitalreserves: "Reservas de capital",
      Surplusreserves: "Reservas excedentes",
      Undistrbutedporfit: "Lucro não distribuído",
      Totalassets: "Ativo Total",
      Turnover: "Rotatividade",
      Costofgoodssold: "Custo dos produtos vendidos",
      Salestax: "Imposto sobre as vendas",
      Grossprofit: "Lucro bruto",
      Otheroperatingprofils: "Outros perfis operacionais",
      Salesexpense: "Despesa de vendas",
      Managementexpense: "Despesas de gestão",
      Financeexpense: "Despesa financeira",
      Operatingprofit: "Lucro operacional",
      Nonoperatingincome: "Receitas não operacionais",
      Profitbeforetax: "Resultado antes dos impostos",
      Incometax: "Imposto de rendimento",
      Netincome: "Resultado líquido",
      DataProblems: "Problemas com os dados",
      CorrectInformation: "Informação correta",
    },
  },
  Home: {
    Applications: "Aplicativos",
    SearchCompanies: "Pesquisar empresas",
    SearchLeads: "Pesquisar leads",
    SearchTrade: "Pesquisar comércio",
    SearchSanctions: "Sanções de pesquisa",
    SearchNews: "Pesquisar notícias",
    RiskScan: "Verificação de risco",
    SearchRelationship: "Relacionamento de pesquisa",
    DataServices: "Serviços de dados",
    SearchCountries: "Pesquisar países",
    selectCountry: "Selecione o país",
    Entercompanyname: "Introduza o nome da empresa",
    keWord: "Palavra-chave",
    firstWord: "Exatamente à esquerda",
    search: "Buscar",
    homeSeachTitle: "Trazendo o foco para os negócios globais",
    homeTitleDetail:
      "A CSI, uma empresa de pesquisa e TI orientada por dados, é especializada em crédito, risco e big data. Ela oferece ferramentas digitais para investidores e profissionais de negócios globais, utilizando análises e algoritmos avançados para fornecer insights rápidos e visuais que facilitam a tomada de decisões mais inteligentes.",
    phoneTitleDetail:
      "Para pesquisar, visualizar e obter informações da empresa rapidamente, você também pode usar o aplicativo CSI no seu celular.",
    searchCompanyNum:
      "Pesquise mais de 500 milhões de empresas em mais de 200 países e territórios",
    newsHeadTitle:
      "Descubra as estratégias por detrás de cada manchete corporativa.",
    sanctionHeadTitle:
      "Navegue no comércio internacional com confiança, verificando as empresas e os produtos em relação às sanções globais",
    tradeHeadTitle:
      "Transforme dados do comércio global em insights estratégicos de mercado",
    relationshipTitle:
      "Propriedade e controlo absolutos / Presença de investimento / Rede da cadeia de abastecimento / Conformidade simplificada / Mitigação de riscos / Cobertura global",
    IndustryAnalysis: "Análise da Indústria",
    BusinessAnalytics: "Análise de negócios",
    ImportExportData: "Dados de importação-exportação",
    CompanyNews: "Notícias da empresa",
    Sanctions: "Sanções",
    BusinessIntelligence: "Inteligência Empresarial",
    CompanyIdentityVerification: "Verificação da identidade da empresa",
    KYCSolutions: "Soluções KYC",
    OwnershipPenetration: "Penetração de propriedade",
    CompanyFinancialAnalysis: "Análise Financeira da Empresa",
    CreditRatings: "Avaliações de crédito",
    CreditReports: "Relatórios de crédito",
    ESGRatings: "Classificações ESG",
    VendorScreening: "Triagem de Fornecedores",
    MarketResearch: "Pesquisa de mercado",
    EnterKeyword: "Introduza a palavra-chave",
    Country: "País",
    Company: "Empresa",
    Person: "Pessoa",
    Product: "Produto",
    EnterPersonName: "Introduza o nome da pessoa",
    EnterCountryName: "Introduza o nome do país",
    EnterproductName: "Introduza as palavras-chave do produto",
    EnterproductNamekeywordsorHSCode:
      "Digite palavras-chave do produto ou código HS",
    Searchby: "Pesquisar por",
    SICStandardIndustryCode: "SIC - Código Padrão da Indústria",
    HSCodeHarmonizedSystemCode: "Código HS - Código do Sistema Harmonizado",
    AIAssistance: "Assistência de IA",
    EnterISICNACENAICSCSICAAAICGICS: "Introduza ISIC/NACE/NAICS/CSIC/AAAIC/GIS",
    EnterHarmonizedSystemCode: "Introduza o código do Sistema Harmonizado",
    SIC: "SIC",
    HSCode: "HSCode",
    Tips: "Dicas",
    detailconttext:
      "A funcionalidade que está a tentar aceder faz parte dos benefícios da nossa subscrição premium. Para obter acesso a esta funcionalidade e usufruir de todos os benefícios premium, subscreva o nosso plano de subscrição.",
    Subscribe: "Inscreva-se",
  },
  Toolbar: {
    Filter: "Filtro",
    Select: "Selecionar",
    Edit: "Editar",
    Sortby: "Classificar por",
    Collect: "Coletar",
    Saved: "Salvos",
    Compare: "Comparar",
    Export: "Exportar",
    Download: "Baixar",
    Update: "Atualizar",
    Reporterror: "Relatar erro",
    Share: "Compartilhar",
    ascending: "ascendente",
    descending: "descendente",
    Yourfolder: "Sua pasta",
    RiskScanning: "Análise de Riscos",
    CreditAssessment: "Avaliação de Crédito",
    DataAnalysis: "Análise de dados",
    NewPortfolio: "Novo Portfólio",
    Print: "Imprimir",
    Optimize: "Otimizar",
    ALL: "Todos",
    Confirm: "Confirmar",
  },
  Export: {
    Choosethedatafields: "Selecione os campos de dados que pretende exportar.",
    Enterkeywords: "Introduza a palavra-chave",
    Financialdata: "Dados financeiros",
    Reset: "Reiniciar",
    Back: "Costas",
    Howmanyresults:
      "Quantos resultados gostaria de exportar desta pesquisa? Também pode refinar a sua pesquisa incluindo filtros adicionais.",
    FileName: "Nome do ficheiro",
    Pleaseenterafilename: "Por favor, introduza um nome de ficheiro.",
    SelectedList: "Lista selecionada",
  },
  AiZaba: {
    whatareyousearchingfor: "o que procura",
    CreditAnalyst: "Analista de Crédito",
    Assesses:
      "Avalia a qualidade de crédito de uma empresa, identifica riscos financeiros, garantindo transações seguras através da análise de dados e classificações de crédito.",
    LegalAdvisor: "Consultor Jurídico",
    Provides:
      "Fornece orientação de conformidade, analisa contratos e avalia riscos legais para garantir que as operações comerciais estão alinhadas com as leis e evitar disputas.",
    BizConsultant: "Consultor de negócios",
    Optimizes:
      "Otimiza as cadeias de abastecimento, identifica compradores e aumenta as vendas analisando as tendências de mercado e oferecendo estratégias personalizadas para melhorar a eficiência.",
    EconomicAnalyst: "Analista Econômico",
    Analyzes:
      "Analisa as tendências económicas da indústria e da região, ajudando as empresas tomam decisões informadas e mantêm-se competitivas.",
    HiImZabaYourresearchassistant:
      "Olá, eu sou a Zaba - A sua assistente de investigação",
  },
  navigationBar: {
    Notifications: "Notificações", //通知
    MarkasRead: "Marcar como Lido", //标记已读
    Viewall: "Ver tudo", //查看全部
    SilverSubscriber: "Assinante Silver", //银级用户
    GoldSubscriber: "Assinante Gold", //金级用户
    SubscriptionExpires: "A subscrição expira",
    AvailableCredits: "Créditos Disponíveis", //可用积分
    AddCredits: "Adicionar Créditos", //购买积分
    IndivdualAccount: "Conta Individual", //个人账号
    GroupAccount: "Conta de Grupo", //集团账号
    UserAccount: "Conta de utilizador",
    Roles: "Funções", //角色
    Thereiscurrentlynonewnews: "Não há novas notícias de momentov",
    EnterTitleContent: "Digite o conteúdo do título",
  },
  ListofResults: {
    Country: "País",
    Industry: "Setor",
    CompanyType: "Tipo de Empresa",
    CompanySize: "Tamanho da Empresa",
    CompanyStatus: "Status da Empresa",
    CompanyName: "Nome da Empresa",
    RegStatus: "Status Registrado",
    StateProvince: "Estado/Província",
    CityCounty: "Cidade/Condado",
    DistrictCity: "Distrito/Cidade",
    IncDate: "Data de Inscrição",
    LegalForm: "Forma Legal",
    CoID: "ID da Empresa",
    TaxNo: "Número de Contribuinte",
    ListingInfo: "Informações do Anúncio",
    Phone: "Telefone",
    Website: "Site",
    Email: "E-mail",
    LegalPerson: "Pessoa Jurídica",
    PostCode: "CEP",
    ISIC: "ISIC",
    IndustryDescription: "Descrição do Setor",
    NACE: "NACE",
    NAICS: "NAICS",
    CreditRating: "Classificação de Crédito",
    SolvencyIndex: "Índice de Solvência",
    ProbabilityofDefault: "Probabilidade de Inadimplência",
    NoofEmployees: "Número de Funcionários",
    Revenue: "Receita",
    TotalAsset: "Ativo Total",
    NetProfit: "Lucro Líquido",
    ROA: "ROA",
    ROE: "ROE",
    ShowMore: "Mostrar Mais",
    SelectCountry: "Selecione o país",
    ClearAll: "Limpar tudo",
    SelectIndustry: "Selecione a indústria",
    ListedCompany: "Empresa listada",
    YearsinBusiness: "Anos no negócio",
    Sharethisinformation: "Partilhe esta informação",
    Pleaseaddress: "Por favor introduza um ou mais endereços de e-mail",
    Example: "Exemplo",
    message: "mensagem",
    pleaseleaveamessage: "por favor deixe mensagem",
    Include: "Incluir",
    thisaddress: "este nome da empresa, ID, endereço",
    CSIwebsite: "Site do CSI",
    Update: "Atualizar",
    Iftheavailable:
      "Se os dados online disponíveis forem insuficientes ou desatualizados, pode clicar no botão “Atualizar” para solicitar uma atualização instantânea de um novo relatório de crédito empresarial investigado aos nossos investigadores de redes locais ou agências de relatórios de crédito. O custo desta atualização é de 1 crédito por empresa. O relatório de atualização demora normalmente 24 a 72 horas a ser entregue.",
    Abusinesscredit:
      "Um relatório de crédito empresarial fornece informações detalhadas sobre os dados de identificação da empresa em questão, registos de registo, estrutura acionista, histórico da empresa, descrição da gestão, empresas relacionadas, operações reais, referências comerciais, dados e análises financeiras, informações públicas oficiais, tais como registos de litígios e sanções, e análise e avaliação de crédito.",
    Searchcompanies: "Pesquise mais e-mails de outras empresas",
    Rowsperpage: "Linhas por página",
    Remove: "Remover",
    Confirm: "Confirmar",
  },
  ContentTabs: {
    Background: "Histórico",
    BusinessActivities: "Atividades Comerciais",
    Performance: "Desempenho",
    Publications: "Publicações",
    CreditOpinion: "Opinião de Crédito",
    MarketAnalysis: "Análise de Mercado",
    Snapshot: "Instantâneo",
    Profile: "Perfil",
    Ownership: "Propriedade",
    RelatedCompanies: "Empresas Relacionadas",
    Management: "Gestão",
    Operations: "Operações",
    Locations: "Localizações",
    Industry: "Setor",
    ImportExport: "Importação e Exportação",
    SupplyChain: "Cadeia de Suprimentos",
    FinancialHighlights: "Destaques Financeiros",
    RatioAnalysis: "Análise de Índices",
    IndustryNorm: "Norma do Setor",
    News: "Notícias",
    Sanctions: "Sanções",
    IndustryStatistics: "Estatísticas do Setor",
    RatingAnalysis: "Análise de Rating",
    CompetitiveAnalysis: "Análise Competitiva",
  },
  Snapshot: {
    CompanyDQIdesc1:
      "O Índice de Qualidade de Dados (DQI) emprega algoritmos para avaliar diferentes aspetos dos dados, incluindo a integridade, validade, fiabilidade das fontes, consistência, atualidade e suporte bilingue.",
    CompanyDQIdesc2:
      "O índice foi concebido para avaliar a qualidade dos dados numa escala de 1 a 100, sendo que pontuações mais elevadas indicam uma qualidade superior dos dados. Os algoritmos podem analisar dados com base em regras ou critérios predefinidos, permitindo medições objetivas e padronizadas.",
    CompanyDQIdesc3:
      "O nosso Índice de Qualidade de Dados (DQI) serve como um indicador fiável, permitindo aos utilizadores avaliar quantitativamente a qualidade dos dados. Isto permite a tomada de decisões orientada por dados e aumenta o valor global e a utilidade dos dados.",
    CountryDQIdesc1:
      "O Índice de Qualidade de Dados (DQI) avalia a fiabilidade, precisão e acessibilidade dos dados entre países, reflectindo diferenças na infra-estrutura digital, governação e transparência. As nações desenvolvidas têm normalmente uma classificação mais elevada devido a sistemas de dados fortes, políticas abertas e tecnologia avançada, enquanto as economias em desenvolvimento lutam frequentemente com lacunas em infra-estruturas, regulamentação ou práticas de partilha de dados.",
    CountryDQIdesc2:
      "Os principais fatores incluem a transparência governamental, as leis de proteção de dados e a adoção tecnológica. Um IQD elevado permite melhores decisões políticas e empresariais, enquanto uma pontuação baixa destaca as áreas que necessitam de investimento.",
    CompanyDQI: "DQI da Empresa", //公司数据质量指数 DQI
    CountryDQI: "DQI do País", //国家数据质量指数 DQI
    CompanyTitle: "Índice de Qualidade de Dados (DQI) por Empresa",
    CountryTitle: "Índice de Qualidade de Dados (DQI) por país",
    Address: "Endereço", //地址
    CountyCity: "Condado/Cidade", //县/市
    ProvinceState: "Província/Estado", //省/州
    CountryRegion: "País/Região", //国家/地区
    ZipCode: "CEP", //邮政编码
    Website: "Website", //网站
    Email: "E-mail", //电邮
    Tel: "Tel", //电话
    LastUpdate: "Última Atualização", //最近更新
    DataSource: "Fonte de Dados", //数据来源
    LegalStatus: "Situação Legal", //法定状况
    CoID: "ID da Empresa", //公司ID
    CompanyType: "Tipo de Empresa", //公司类型
    RegistrationDate: "Data de Registro", //注册日期
    RegistrationStatus: "Status de Registro", //注册状态
    Listed: "Listada", //上市信息
    CurrentOpperations: "Operações Atuais", //经营状况
    IndustryCode: "Código do Setor", //行业代码
    BusinessActivities: "Atividades Comerciais", //主营业务
    NoofEmployees: "Nº de Funcionários", //员工数量
    NoofShareholders: "Nº de Acionistas", //股东数量
    Management: "Gestão", //管理状况
    Performance: "Desempenho", //业绩表现
    Revenue: "Receita", //收入
    Assets: "Ativos", //资产
    ProfitLoss: "Lucro/Prejuízo", //利润
    Growth: "Crescimento", //公司增长
    Competitiveness: "Competitividade", //竞争力
    CreditOpinion: "Opinião de Crédito", //信用状况
    CreditRating: "Classificação de Crédito", //信用评级
    CreditScore: "Score de Crédito", //信用评分
    ESGRating: "Classificação ESG", //ESG 评级
    Solvency: "Solvência", //偿还能力
    Sanctions: "Sanções", //全球制裁
    CoName: "Nome da Empresa",
    RegName: "Nome registado",
  },
  Profile: {
    CompareCompanies: "Comparar empresas",
    AddaCompany: "Adicionar uma empresa",
    SubjectCompany: "Empresa em questão", //目标公司
    ComparisonCompany: "Empresa de comparação",
    CompanyProfile: "Perfil da Empresa", //基本资料
    CompanyName: "Nome da Empresa", //公司名称
    NativeName: "Nome Próprio", //当地名称
    CompanyID: "ID da Empresa", //公司 ID
    VATNumber: "Número de IVA", //VAT号
    StockCode: "Código da Ação", //股票代码
    Listed: "Listada", //上市日期
    RegistrationDate: "Data de Registro", //注册日期
    LegalForm: "Forma Legal", //公司性质
    CompanyType: "Tipo de Empresa", //公司类型
    LegalStatus: "Situação Legal", //注册状态
    Jurisdiction: "Jurisdição", //司法管辖区
    RegisteredAddress: "Endereço Registrado", //注册地址
    ProvinceState: "Província/Estado", //省/州
    CountryRegion: "País/Região", //国家/地区
    ZipCode: "CEP", //邮政编码
    OperatingAddress: "Endereço Operacional", //经营地址
    LastUpdate: "Última Atualização", //最近更新
    DataSource: "Fonte de Dados", //数据来源
    History: "Histórico", //历史记录
    RegisteredCapital: "Capital Registado",
    PaidinCapital: "Capital integralizado",
    CountyCity: "Condado/Cidade",
    OtherName: "Outro nome",
  },
  Ownership: {
    TotalPartiesInvolved: "Total de partes envolvidas",
    UltimateBeneficiaryOwner: "Proprietário Beneficiário Final (UBO)", //最终受益人
    NaturalPersonShareholder: "Acionista Pessoa Singular", //涉及自然人股东
    CorporateShareholders: "Acionistas Corporativos", //涉及法人股东
    ShareholderLevel: "Nível de Acionista", //股东层级x
    Name: "Nome", //名称
    Country: "País", //国家/地区
    Location: "Localização", //地点
    Type: "Tipo", //类型
    Shares: "Ações", //股份
    Relation: "Relação", //关系
    RelatedCompany: "Empresas relacionadas",
    CompanyShareholders: "Acionistas da Sociedade",
    NGOShareholders: "Acionistas de ONG",
    SubjectInvestments: "Investimentos do Sujeito",
  },
  RelatedCompanies: {
    Total: "Total de entidades", //相关公司总计
    Countries: "Países", //国家/地区
    Branches: "Filiais", //分支机构
    RelatedComp: "Empresas Relacionadas", //关联公司
    Name: "Nome", //名称
    Country: "País", //国家/地区
    Location: "Localização", //地点
    Type: "Tipo", //类型
    Relationship: "Relação", //关系
    BranchOffices: "Filiais",
    Subsidiaries: "Subsidiárias",
  },
  Management: {
    Management: "administração", //管理层
    ContactInfo: "Informações de contato", //联系人信息
    Countries: "Países", //国家/地区
    Name: "Nome", //名称
    Position: "Cargo", //职位
    Department: "Departamento", //部门
    Country: "País", //国家/地区
    ShareholderNot: "Acionista ou não", //是否股东
    Relation: "Relacionamentos", //关系
    Verification: "Verificação", //已验证
    Searchmoreemails: "Pesquisar mais e-mails", //搜索更多电邮
    Roles: "Funções", //角色
    EducationLevel: "Nível de escolaridade", //教育程度
    Phone: "Telefone", //电话
    Email: "E-mail", //电邮
    Verified: "Verificado", //已验证
    Searchmore: "Pesquisar mais e-mails de outras empresas", //搜索更多其他公司的电邮
    Pleaseentername: "Por favor insira o nome",
    PleaseenterWebsite: "Por favor, introduza o nome da empresa ou o domínio",
    UserSelfVerification: "Autoverificação do utilizador",
    Userverified: "Utilizador verificado",
    Source: "Origem",
  },
  Operations: {
    LineofBusiness: "Ramo de Atividade", //业务范围
    BusinessTerritories: "Territórios Comerciais", //业务区域
    ImportExport: "Importação e Exportação", //进出口信息
    Viewtradeinfo: "Ver mais informações comerciais", //查看更多贸易信息
    ProductsServices: "Produtos/Serviços", //产品/服务
    Products: "Produtos", //产品
    ProductImage: "Imagem do Produto", //产品图片
    ProductName: "Nome do Produto", //产品名称
    ProductDescription: "Descrição do Produto", //产品描述
    Details: "Detalhes", //详情
    Addproductinformation: "Adicionar informações do produto", //添加产品信息
    Showcaseyourcompany:
      "Se desejar apresentar os produtos ou serviços da sua empresa ao público, pode adicionar aqui as informações do seu produto e serviço. Esta é uma ótima forma de promover o seu negócio. Depois de analisarmos o seu envio, os seus dados serão publicados.",
  },
  Locations: {
    CoName: "Nome da Empresa", //业务范围
    Relationship: "Relação", //关系
    Type: "Tipo", //类型
    Country: "País", //国家/地区
    Location: "Localização", //地点
    Address: "Endereço", //地址
    Edit: "Editar", //编辑
    CompanyLocatiionsMap: "Localizações da Empresa no Mapa", //地图中的公司位置
    Selectaddresstype: "Selecione o tipo de endereço", //选择地址类型
    Subjectcompany: "Empresa em questão", //目标公司
    Subsidiary: "Subsidiária", //子公司
    RegisteredAddress: "Endereço Registrado", //注册地址
    OperationAddress: "Endereço Operacional", //运营地址
    All: "Todos", //全部
    Showlocation: "Mostrar locais",
  },
  Industry: {
    IndustryTitle: "Título da Indústria", //IndustryTitle
    IndustryDescription: "Descrição da Indústria", //IndustryDescription
    ISIC: "ISIC", //ISIC
    ISICDescription: "Descrição do ISIC", //ISICDescription
    NACE: "NACE", //NACEDescription
    NACEDescription: "Descrição do NACE", //NACEDescription
    NAICS: "NAICS", //NAICS
    NAICSDescription: "Descrição do NAICS", //NAICSDescription
    CSIC: "CSIC", //CSIC,
    CSICDescription: "Descrição do CSIC", //CSICDescription
    AAAIC: "AAAIC", //AAAIC
    AAAICDescription: "Descrição do AAAIC", //AAAICDescription
    GICS: "GICS", //GICS
    GICSDescriptio: "Descrição do GICS", //GICS 描述
  },
  ImportExport: {
    TotalImportAmount: "Valor Total de Importação", //进口总额
    TopImportCountry: "Principal País Importador", //最大进口国家/地区
    TopImportProduct: "Principal Produto Importador", //最大进口产品
    TotalExport: "Valor total das exportações", //出口总额
    TopExportCountry: "Principal País Exportador", //最大出口国家/地区
    TopExportProduct: "Principal Produto Exportador", //最大出口产品
    TradeVolume: "Volume de Comércio", //贸易额
    ImportShipments: "Remessas de Importação", //进口量
    ExportShipments: "Remessas de Exportação", //出口量
    ImportCountries: "Países Importadores", //进口国家/地区
    ExportCountries: "Países Exportadores", //出口国家/地区
    ImportVolume: "Volume de Importação", //进口量
    ExportVolume: "Volume de Exportação", //出口量
    Suppliers: "Principais Fornecedores", //主要供应商
    Shipments: "Por Número de Remessas", //按出货量
    Buyers: "Principais Compradores", //主要买家
    ImportQuantity: "Quantidade Importada", //进口数量
    IncreaseDecreasexRate: "Taxa de Aumento/Diminuição", //增/减率
    ExportQuantity: "Quantidade Exportada", //出口数量
    ImportsExportsRecords: "Registros de Importação e Exportação", //进出口记录
    Date: "Data", //日期
    Product: "Produto", //产品
    HSCode: "Código SH", //HS 编码
    BuyerName: "Nome do Comprador", //买家名称
    Destination: "Destino", //目的地
    SupplierName: "Nome do Fornecedor", //供应商名称
    Origin: "Origem", //原产地
    Amount: "Valor (USD)", //金额
    Details: "Detalhes", //详情
    Imports: "Importações",
    Exports: "Exportações",
    Shipments2: "Remessas",
    value2: "valor",
    value: "Por número de valor",
    viewmoretradeinfo: "consulte mais informações comerciais",
    SearchHSCode: "Pesquisar código HS",
    Selectdate: "Selecione a data",
  },
  SupplyChain: {
    Illustratesthesubjectcompany:
      "Este gráfico ilustra as relações “comprar a” e “vender a” da empresa em questão. Quanto maior for o volume, mais grosso é o tubo.",
  },
  ShippingOrderDetails: {
    Date: "Data",
    MasterBillofLading: "Conhecimento Mestre de Embarque",
    Source: "Origem",
    BillNo: "Número do Conhecimento",
    ImporterBuyer: "Importador / Comprador",
    ExporterSeller: "Exportador / Vendedor",
    Name: "Nome",
    Address: "Endereço",
    Country: "País",
    Contact: "Contato",
    Email: "E-mail",
    CargoInfo: "Informações da Carga",
    HSCode: "Código SH",
    Quantity: "Quantidade",
    WeightUnit: "Unidade de Peso",
    ProductDescription: "Descrição do Produto",
    Amount: "Valor (USD)",
    QuantityUnit: "Unidade de Quantidade",
    Weight: "Peso",
    HSDescription: "Descrição SH",
    Incoterms: "Incoterms",
    ShippingInfo: "Informações de Embarque",
    Vessel: "Embarcação",
    Consignee: "Destinatário",
    MeansofTransport: "Meio de Transporte",
    CountryofOrigin: "País de Origem",
    Voyage: "Viagem",
    Notifier: "Notificador",
    CountryofDestnation: "País de Destino",
    AddressofOrigin: "Endereço de Origem",
    Shipper: "Remetente",
    AddressofDestnation: "Endereço de Destino",
    Container: "Contêiner",
    ContainerID: "ID do Contêiner",
    ContainerType: "Tipo de Contêiner",
    ContainerDescDode: "Código de Descrição do Contêiner",
    ContainerSize: "Tamanho do Contêiner",
    ImportExport: "Importador/Exportador",
    Imports: "Importações",
    Exports: "Exportações",
  },
  FinancialHighlight: {
    Revenue: "Receita", //收入
    Profit: "Lucro", //利润
    Growth: "Crescimento", //增长
    CashFlowStatus: "Situação do Fluxo de Caixa", //现金流状况
    FinancialStructure: "Estrutura Financeira", //融资结构
    CreditOpinion: "Opinião de Crédito", //信用评估
    RiskIndicator: "Indicador de Risco", //风险指标
    Solvencyindex: "Índice de Solvência", //偿还指数
    Year: "Ano", //年份
    Change: "Variação", //变化
    NetProfit: "Lucro Líquido",
    TotalAssets: "Ativo Total",
    Equity: "Patrimônio Líquido",
    GrossMargin: "Margem Bruta",
    ProfitMargin: "Margem de Lucro",
    ReturnonEquity: "Retorno sobre o Patrimônio Líquido",
    CurrentRatio: "Índice de Liquidez Corrente",
    DebtRatio: "Índice de Endividamento",
    FinancialHighlights: "Dados Financeiros das Empresas Relacionadas", //关联公司财务数据
    FinancialHighlightsTitle: "Destaques Financeiros das Empresas Relacionadas", //关联公司财务摘要
    CompanyName: "Nome da Empresa", //公司名称
    CompanyID: "ID da Empresa", //公司ID
    Country: "País", //国家/地区
    CompanyStatus: "Situação da Empresa", //公司状态
    Cancel: "Cancelar", //取消
    Select: "Selecionar",
    Relations: "Relacionamentos", //关系
    Financialperformancedata:
      "Os dados de desempenho financeiro são recolhidos de diversas fontes governamentais e agências locais de relatórios de crédito. Além disso, são utilizadas pesquisas de mercado e da indústria para calcular e modelar os dados. Para obter informações mais detalhadas sobre as operações reais e a análise de desempenho, contacte a nossa equipa de atendimento para solicitar um relatório de due diligence da empresa.",
    Whenthesubjectsdata:
      "Quando os dados do assunto são insuficientes, ou está interessado em obter mais insights sobre o seu cliente, esta plataforma oferece uma visão abrangente de todas as entidades relacionadas com o assunto. Isto inclui os acionistas da empresa do assunto, empresas relacionadas e muito mais.",
    Byprovidingyou:
      "Ao fornecer uma perspetiva mais ampla, esta plataforma permite-lhe fazer avaliações mais informadas e obter uma compreensão mais profunda do seu assunto.",
    PleaseSelectTheYeartoDisplay: "Selecione o ano para visualizar",
    SelectUptoThreeYears: "Selecione até três anos",
  },
  RatioAnalysis: {
    ProfitabilityRatios: "Índices de Lucratividade",
    Year: "Ano",
    Change: "Variação",
    Returnonequity: "Retorno sobre o Patrimônio Líquido",
    Returnonassets: "Retorno sobre os Ativos",
    Profitmargin: "Margem de Lucro",
    Grossmargin: "Margem Bruta",
    OperatingRatios: "Índices Operacionais",
    Assetsturnover: "Giro de Ativos",
    Stockturnover: "Giro de Ações",
    Salesperiod: "Período de Vendas",
    Collectionperiod: "Período de Cobrança",
    Creditperiod: "Período de Crédito",
    StructuralRatios: "Índices de Estrutura",
    Currentratio: "Índice de Liquidez Corrente",
    Quickratio: "racio rápido",
    Shareholdersliquidityratio: "Índice de Liquidez Acionária",
    Solvencyratio: "Índice de Solvência",
    Debtratio: "Índice de Endividamento",
    ProductivityRatios: "Índices de Produtividade",
    Profitperemployee: "Lucro por Funcionário",
    Operatingrevenueperemployee: "Receita Operacional por Funcionário",
    Shareholdersfundsperemployee: "Capital Próprio por Funcionário",
    Totalassetsperemployee: "Ativo Total por Funcionário",
    GrowthRatios: "Índices de Crescimento",
    Salesgrowthrate: "Taxa de Crescimento das Vendas",
    Netprofitgrowthrate: "Taxa de Crescimento do Lucro Líquido",
    Totalassetsgrowthrate: "Taxa de Crescimento do Ativo Total",
    FinancialHighlights: "Dados Financeiros das Empresas Relacionadas", //关联公司财务数据
    RatioAnalysis: "Análise dos Índices das Empresas Relacionadas", //关联公司比率分析
    CompanyName: "Nome da Empresa",
    CompanyID: "ID da Empresa",
    Country: "País",
    CompanyStatus: "Status da Empresa",
    Relations: "Relacionamentos",
  },
  IndustryNorms: {
    IndustryStatistics: "Estatísticas do Setor",
    ofcompaniesintheIndustry: "Nº de empresas no Setor",
    oflistedCompaniesintheIndustry: "Nº de empresas listadas no Setor",
    oflargecompaniesintheIndustry: "Nº de grandes empresas no Setor",
    ofSMEsintheIndustry: "Nº de PMEs no Setor",
    ofcompaniesinsample: "Nº de empresas na amostra",
    ofcompaniesinloss: "Nº de empresas com prejuízo",
    Observations: "Observações",
    AverageValue: "Valor Médio",
    MedianValue: "Valor Mediano",
    MaximumValue10: "Valor Máximo 10%",
    MinimumValue10: "Valor Mínimo 10%",
    SubjectCompany: "Empresa em Estudo",
    YearsinBusiness: "Anos de Atividade",
    TotalAssets: "Total de Ativos",
    TotalEquity: "Patrimônio Líquido Total",
    Revenue: "Receita",
    NetEarning: "Lucro Líquido",
    Returnonassets: "Retorno sobre Ativos",
    Performance: "Desempenho",
    ProfitabilityRatios: "Índices de Rentabilidade",
    Returnonequity: "Retorno sobre Patrimônio Líquido",
    Grossmargin: "Margem Bruta",
    OperatingRatios: "Índices Operacionais",
    Stockturnover: "Giro de Ações",
    Accountsreceivableturnover: "Giro de Contas a Receber",
    Assetsturnover: "Giro de Ativos",
    Totalassetturnover: "Giro de Ativos Total",
    StructuralRatios: "Índices de Estrutura",
    Currentratio: "Índice de Liquidez Corrente",
    Quickratio: "racio rápido",
    Shareholdersliquidityratio: "Índice de Liquidez Acionária",
    GrowthRatios: "Taxas de Crescimento",
    Salesgrowthrate: "Taxa de crescimento das vendas",
    Netprofitgrowthrate: "Taxa de crescimento do lucro líquido",
    Totalassetsgrowthrate: "Taxa de crescimento do ativo total",
  },
  Lawsutis: {
    Litigations: "Litígios",
    Date: "Data",
    CaseType: "Tipo de caso",
    Title: "Título do caso",
    CaseNo: "Caso nº.",
    CauseofAction: "Causa da Ação",
  },
  News: {
    Date: "Data", //日期
    Title: "Título", //标题
    Source: "Fonte", //来源
    Impact: "Impacto", //影响
    Searchcompanies: "Pesquise mais notícias sobre outras empresas", //国家/地区
    SearchforTitle: "Buscar título",
    CompanyName: "Nome da empresa",
    Industry: "Indústria",
    Subjects: "Assuntos",
    NewsTypes: "Tipos de notícias",
    ByDate: "Por data",
    SelectCompanyName: "Selecione o nome da empresa",
    SelectIndustry: "Selecione a indústria",
    SelectSubjects: "Selecione os assuntos",
    SelectNewsType: "Selecione o tipo de notícia",
    Negative: "Negativa",
    Positive: "Positiva",
  },
  Sanctions: {
    Potentialcompliance: "Possíveis riscos de conformidade detectados", //检测到潜在合规风险
    SeachbuttonNo: "Nada prejudicial detectado nesta empresa", //未检测到任何与该公司相关的不良记录
    SeachbuttonYes:
      'Para pesquisar mais registros de sanções, clique no botão "Pesquisar Sanções".', //要搜索更多制裁记录，请点击“搜索制裁”按钮。
    SearchSanctions: "Pesquisar Sanções", //搜索制裁
    ViewDetails: "Ver Detalhes", //查看详情
    Sanctions: "Sanções", //制裁
    Potentialcompliancerisks: "Possíveis riscos de conformidade", //潜在合规风险
    IDInfo: "Informações do ID", //ID 信息
    IDType: "Tipo de ID", //ID 类型
    IDDescription: "Descrição do ID", //ID 描述
    SanctionList: "Lista de Sanções", //制裁名单
    SanctionListInvolved: "Lista de Sanções Envolvidas", //涉及的制裁名单
    StartDate: "Data de Início", //生效日期
    EndDate: "Data de Término", //结束日期
    SourceList: "Lista de Fontes", //来源名单
    SourceName: "Nome da Fonte", //来源名称
    ProfileNotes: "Observações do Perfil", //主体资料
    Link: "Link", //链接
    Name: "Nome", //名称
    AssociationList: "Lista de associações",
    AssociationID: "ID da associação",
    AssociationType: "Tipo de associação",
  },
  CreditOpinion: {
    CreditAssessment: "Avaliação de Crédito",
    CreditAssessmentfromtheRelatedCompanies:
      "Avaliação de Crédito das Empresas Relacionadas",
    Year: "Ano",
    CreditRating: "Classificação de Crédito",
    LocalCreditScore: "Pontuação de Crédito Local",
    ProbabilityofDefault: "Probabilidade de Inadimplência",
    SolvencyIndex: "Índice de Solvência",
    CreditLine: "Linha de Crédito",
    RiskIndicator: "Indicador de Risco",
    RelatedCreditAssessment: "Avaliação de Crédito Relacionada",
    CompanyName: "Nome da Empresa",
    CompanyID: "ID da Empresa",
    Country: "País",
    CompanyStatus: "Status da Empresa",
    Relations: "Relacionamentos",
    Cancel: "Cancelar", //取消
    Select: "Selecionar",
    CreditAssessmentMessage1:
      "Quando os dados do assunto são insuficientes, ou está interessado em obter mais insights sobre o seu cliente, esta plataforma oferece uma visão abrangente de todas as entidades relacionadas com o assunto. Isto inclui os acionistas da empresa do assunto, empresas relacionadas e muito mais.",
    CreditAssessmentMessage2:
      "Ao fornecer uma perspetiva mais ampla, esta plataforma permite-lhe fazer avaliações mais informadas e obter uma compreensão mais profunda do seu assunto.",
    LocalCreditRating: "Classificação de crédito local",
    LocalCreditRatingDetail:
      "Impulsionado pelo poder do big data, o 3ARating é um sistema de classificação quantitativa para empresas privadas. É um esforço colaborativo entre a 3ACredit e a Creditreform Rating. O modelo de classificação é construído com base numa avaliação abrangente de vários fatores-chave, incluindo fatores não financeiros, fatores financeiros, registos negativos e considerações específicas do setor. O modelo de rating apresenta um coeficiente de Gini impressionante, indicando a sua robustez e fiabilidade. 3ARating abrange uma gama de classificações, desde a classificação mais elevada, 3A1, até à classe de classificação mais baixa, 3A19.",
    CreditScore: "Pontuação de crédito",
    CreditScoreDetail:
      "As pontuações de crédito são calculadas numa escala de 1 a 100, com base na classificação de crédito obtida junto das autoridades locais. Uma pontuação mais elevada indica uma melhor qualidade de crédito.",
    PossibilityofDefault: "Possibilidade de Incumprimento (PD)",
    PossibilityofDefaultDetail:
      "A Possibilidade de Incumprimento (PD) é uma ferramenta útil para a avaliação de risco, com foco na avaliação da liquidez de curto prazo.",
    SolvencyIndexSI: "Índice de Solvência (SI)",
    SolvencyIndexSIDetail:
      "O Índice de Solvência (SI) é um indicador de alerta precoce altamente eficaz e fiável que permite uma avaliação rápida da solvência dos parceiros de negócio. Um valor de SI mais elevado indica um risco mais elevado de incumprimento por parte de um cliente. O IS varia entre 100, que é considerada uma classificação excelente, e 600, onde estão presentes características altamente negativas.",
    ExternalRating: "Avaliação Externa",
    DefaultProbability: "Probabilidade padrão (Pd1Year)",
    Rating: "3ARClassificação (>=,<=)",
    PleaseSelectTheYeartoDisplay: "Selecione o ano para visualizar",
    SelectUptoThreeYears: "Selecione até três anos",
    HighRisk: "Alto risco",
    Medium: "Média",
    Moderate: "Moderada",
    Average: "Média",
    LowerThanAvg: "Abaixo da média",
    LowRisk: "Baixo risco",
    CreditOpinion: "Opinião de Crédito",
  },
  IndustryStatistics: {
    SubjectCompany: "Empresa em Assunto",
    Country: "País",
    Compare: "Comparar",
    Industry: "Setor",
    CompanyType: "Tipo de Empresa",
    CompanySize: "Tamanho da Empresa",
    CompanyStatus: "Status da Empresa",
    YearsinBusiness: "Anos de Atividade",
    CompanyRating: "Classificação da Empresa",
    Liquidity: "Situação do Fluxo de Caixa",
    NoofcoinIndustry: "Nº de co. na indústria",
    IndustryRating: "Classificação da indústria",
    Profitability: "Rentabilidade",
    Growth: "Crescimento",
    FinancialStructurt: "Estrutura Financeira",
    Solvency: "Solvência",
    SearchCountry: "Pesquisar país",
  },
  RatingAnalysis: {
    IndustyAnalysis: "Análise do Setor",
    GeographicAnalysis: "Análise Geográfica",
    CompanyTypeAnalysis: "Análise do Tipo de Empresa",
    BiusinessScaleAnalysis: "Análise da Escala de Negócios",
    HistoryAnalysis: "Análise Histórica",
    NormalDistribution: "Distribuição Normal",
    SubjectCompany: "Empresa em Questão",
    Probabilityofthesubjectratinginitsindustry:
      "Probabilidade da classificação da empresa em questão em seu setor",
    Maximum: "Máximo 10%",
    Mean: "Média",
    Average: "Média",
    Minimum: "Mínimo 10%",
    RatingDistribution: "Distribuição da Classificação",
    Revenue: "Receita",
    Earning: "Lucro",
    TotalAssets: "Ativo Total",
    Subjectratinginitsindustrybyfinancialindicators:
      "Classificação da empresa em seu setor por indicadores financeiros",
    Best: "Melhor",
    Worst: "Pior",
    Rankingofsubject: "Classificação da classificação da empresa no setor",
    Industy: "Setor",
    Percentilerank:
      "Classificação percentual: % de empresas com pontuação igual ou inferior à classificação da empresa",
    Historicaldevelopmentofsubject:
      "Desenvolvimento histórico da classificação da empresa em seu setor",
    IndustryAverage: "Média do Setor",
    SubjectRatingChanges: "Mudanças na Classificação da Empresa",
    CreditScore: "Pontuação de crédito",
    NOofCompanies: "Nº de empresas",
    ofCompanies: "% de empresas",
    CreditRating: "Classificação de crédito",
    CompanySize: "Tamanho da Empresa",
    YearsinBusiness: "Anos no negócio",
    SubjectsIndustryConcentrationAnalysis:
      "Análise de concentração da indústria do sujeito",
    GeographicdistributionofSubjectsratingintsindustry:
      "Distribuição geográfica da classificação do Assunto no seu setor",
    GeographicdistributioninSubjectindustry:
      "Distribuição geográfica na indústria do assunto",
    RatingDistributioninSubjectsLocation:
      "Distribuição da classificação na localização do sujeito",
    Ratinganalysisofcompanies:
      "Análise de classificação de empresas do mesmo setor com diferentes anos de experiência",
    Subjectsratinghistory:
      "Histórico de classificação do sujeito em comparação com os seus pares com o mesmo histórico",
    Ratingrankingofcompanieswithsamehistory:
      "Ranking de classificação das empresas com o mesmo histórico",
    Ratingstatistics:
      "Estatísticas de classificação das empresas com os mesmos anos de atividade",
    Subjectratingcomparing:
      "Classificação do assunto comparando com as suas empresas pares com o",
    Subjectratinginitsgroup: "Avaliação do assunto no seu grupo",
    Analysisbasedonnature:
      "Análise baseada na natureza das empresas do setor em causa",
    Subjectratingpositioninitscompanytype:
      "Posição de classificação do sujeito no seu tipo de empresa",
    Ratingstatisticsofcompanies:
      "Estatísticas de classificação de empresas do mesmo setor",
    Ratinganalysisofcompanies:
      "Análise de rating de empresas de diferentes dimensões no mesmo setor",
    Probabilityofsubjectrating:
      "Probabilidade de classificação de assuntos no seu setor dentro do seu tamanho",
    Subjectratingcomparingwithindustry:
      "Classificação do sujeito em comparação com os seus pares no seu setor",
    RatingRankingofthecompanies:
      "Rating Ranking das empresas da mesma dimensão no mesmo setor",
    Ratingstatisticsofcompanies:
      "Estatísticas de classificação de empresas do mesmo tamanho e do mesmo setor",
    Rank: "Classificação",
    Rating: "classificação",
    CompanyType: "Tipo de Empresa",
  },
  CompetitiveAnalysis: {
    MarketPosition: "Posição de Mercado",
    Revenus: "Receita",
    NetEarnings: "Lucro Líquido",
    NetAssets: "Ativo Líquido",
    TotalAssets: "Ativo Total",
    Employees: "Funcionários",
    Mean: "Média",
    Average: "Média",
    Maximum: "Máxima (10%)",
    Worst: "Pior (10%)",
    Subjectcompany: "Empresa em questão",
    PerformanceComparison: "Comparação de Desempenho",
    ProfitabilityRatios: "Índices de Rentabilidade",
    Grossmargin: "Margem Bruta",
    Returnonassets: "Retorno sobre o Ativo",
    Returnonequity: "Retorno sobre o Patrimônio Líquido",
    OperatingRatios: "Índices Operacionais",
    Stockturnover: "Giro de Estoque",
    Assetsturnover: "Giro de Ativo",
    Currentassetturnoverrate: "Taxa de rotação atual de ativos",
    Collectionperiod: "Período de Cobrança",
    GrowthRatios: "Índices de Crescimento",
    Totalassetsgrowthrate: "Taxa de Crescimento do Ativo Total",
    Salesgrowthrate: "Taxa de Crescimento das Vendas",
    Netprofitgrowthrate: "Taxa de Crescimento do Lucro Líquido",
    StructuralRatios: "Índices de Estrutura",
    Debtratio: "Índice de Endividamento",
    Quickratio: "racio rápido",
    Currentratio: "Índice de Liquidez Corrente",
  },
  AccountCenterMenu: {
    SearchinSettings: "Pesquisar em Configurações", //在“设置”中搜索
    Account: "Conta", //账户
    MyAccount: "Minha Conta", //我的账户
    ContactInfo: "Informações de Contato", //联系信息
    AccountSecurity: "Segurança da Conta", //账户安全
    OrganizationalManagement: "Gerenciamento Organizacional", //组织管理
    UserGroup: "Grupo de Usuários", //用户组
    User: "Usuário", //用户
    Role: "Função", //角色
    MyDatabase: "Meu Banco de Dados", //我的数据库
    MyUsage: "Meu Uso", //我的使用情况
    CompaniesViewed: "Empresas Visualizadas", //查看过的公司
    ReportsDownloaded: "Relatórios Baixados", //下载的报告
    ReportUpdatesOrdered: "Atualizações de Relatórios Solicitadas", //订购的报告更新
    BillingandPayment: "Faturamento e Pagamento", //账单和付款
    BillRecords: "Registros de Faturas", //账单记录
    PaymentRecords: "Registros de Pagamento", //付款记录
    CreditDeductions: "Deduções de Crédito", //信用扣款
    InvoicesDownloaded: "Faturas Baixadas", //下载的发票
    UserSettings: "Configurações do Usuário", //用户设置
    Messages: "Mensagens", //消息
    Notifications: "Notificações", //通知
    HelpCenter: "Central de Ajuda", //帮助中心
    FAQ: "Perguntas Frequentes", //常见问题
    Privacy: "Privacidade", //隐私
    Terms: "Termos", //条款
    ReportIssues: "Problemas com Relatórios", //报告问题
    UserGuide: "Guia do Usuário", //用户指南
    AboutCSI: "Sobre o CSI", //关于CSI
  },
  MyAccount: {
    Logintime: "Horário de login", //登录时间
    SignOut: "Sair", //退出
    DeleteAccount: "Excluir conta", //删除账户
    AccountID: "ID da conta", //账户ID
    Enteranewaddress: "Digite um novo endereço de e-mail", //输入新的电邮
    EnterVerificationCode: "Digite o código de verificação", //输入验证码
    SendverificationCode: "Enviar código de verificação", //发送验证码
    Password: "Senha", //密码
    Originalpassword: "Senha original", //原始密码
    Newpassword: "Nova senha", //新密码
    Confirmnewpassword: "Confirme a nova senha", //确认新密码
    AccountOwnership: "Propriedade da conta", //账户所有权
    IndividualAccount: "Conta individual", //个人账户
    GroupAccount: "Conta de grupo", //集团账户
    Organizationname: "Nome da organização", //机构名称
    CountryRegion: "País/região", //国家/地区
    Address: "Endereço", //地址
    City: "Cidade", //城市
    ZipCode: "CEP", //邮政编码
    FirstName: "Nome", //名字
    LastName: "Sobrenome", //姓氏
    PhoneNumber: "Número de telefone", //电话号码
    Email: "E-mail", //更改
    Change: "Alterar", //更改
    Save: "Salvar", //保存
    Cancel: "Cancelar", //取消
    LastLogin: "Último login", //Last Login
    RecentLogin: "Login recente", //登录尝试次数
    AverageLoginTime: "Tempo médio de login", //平均登录时间
    TotalLoginAttempts: "Total de tentativas de login", //登录尝试次数
    Registrationtime: "Tempo de registo",
    Role: "Função",
    Administrator: "Administrador",
    Enterpriseusers: "Utilizadores corporativos",
    EditImage: "Editar imagem",
    DeleteImage: "Apagar imagem",
  },
  ContactInfo: {
    ContactInfo: "Informações de contato",
    FirstName: "Nome",
    LastName: "Sobrenome",
    PhoneNumber: "Número de telefone",
    Email: "E-mail",
    CountryRegion: "País/Região",
    AddressLine: "Endereço",
    City: "Cidade",
    ZipCode: "CEP",
    Alternativecontactperson: "Contato alternativo",
    Setascontactperson: "Definir como contato",
    Edit: "Editar",
  },
  AccountSecurity: {
    Setupmysecurityquestions: "Configurar minhas perguntas de segurança",
    Pleasechooseaquestion: "Escolha uma pergunta",
    Pleaseentertheanswertothequestion: "Digite a resposta para a pergunta",
    SessionTimeoutAutomaticLogoutSettings:
      "Tempo limite da sessão: Configurações de logout automático",
    Thesystemwillautomatically:
      "O sistema desconectará você automaticamente após um período de inatividade. O tempo limite padrão é de 5 minutos, mas você pode ajustar essa duração conforme necessário.",
  },
  MyDatabase: {
    TotalNumberofCompaniesSearched: "Número Total de Empresas Pesquisadas",
    TotalNumberofCompaniesCollected: "Número Total de Empresas Coletadas",
    TotalNumberofUpdateReportsOrdered:
      "Número Total de Relatórios de Atualização Solicitados",
    Date: "Data",
    UserName: "Nome de Usuário",
    CompanyName: "Nome da Empresa",
    Status: "Status",
    UsageType: "Tipo de Uso",
    Entercompanyname: "Digite o nome da empresa",
    Download: "Baixar",
  },
  OrganizationalManagement: {
    GroupName: "Nome do Grupo",
    ParentGroupName: "Nome do Grupo Principal",
    Organization: "Organização",
    GroupID: "ID do Grupo",
    GroupStatus: "Status do Grupo",
    Operation: "Operação",
    NewlyBuilt: "Recém-criado",
    UserAccount: "Conta de Usuário",
    Role: "Função",
    AccountStatus: "Status da Conta",
    RoleName: "Nome da Função",
    Position: "Cargo",
    RoleStatus: "Status da Função",
    Valid: "Válido",
    Invalid: "Inválido",
    PermissionSettings: "Configurações de Permissão",
    ShowMore: "Mostrar Mais",
    Search: "Buscar",
    Cancel: "Cancelar",
    Confirm: "Confirmar",
    NewGroup: "Novo Grupo",
    EnterGroupName: "Introduza o nome do grupo",
    NumberofGroups: "Número de grupos",
    Groups: "Grupos",
    Roles: "Funções",
    NewRoles: "Novas funções",
    EnterNewRole: "Introduza a nova função",
    Users: "Usuários",
    EnterUserName: "Introduza o nome de utilizador",
  },
  BillingandPayment: {
    TotalNumberofOrders: "Número Total de Pedidos",
    TotalPaymentAmount: "Valor Total do Pagamento",
    TotalUsedCredits: "Total de Créditos Utilizados",
    Date: "Data",
    UserAccount: "Conta do Usuário",
    CompanyName: "Nome da Empresa",
    OrderNo: "Nº do Pedido",
    OrderType: "Tipo de Pedido",
    OrderStatus: "Status do Pedido",
    Download: "Download",
    PaymentAmount: "Valor do Pagamento",
    Contactus: "Fale Conosco",
    DownloadInvoice: "Baixar Fatura",
    CreditUsage: "Utilização do Crédito",
    ReportOrderStatus: "Relatar Status do Pedido",
    CompanyID: "ID da Empresa",
    CountryRegion: "País/Região",
    AddressLine: "Endereço",
    City: "Cidade",
    ZipCode: "CEP",
    FirstName: "Nome",
    LastName: "Sobrenome",
    PhoneNumber: "Número de Telefone",
    Email: "E-mail",
    BankAccountHolderName: "Nome do Titular da Conta Bancária",
    BeneficiaryBankName: "Nome do Banco Beneficiário",
    SWIFTCODE: "CÓDIGO SWIFT",
    AccountNumber: "Número da Conta",
    BeneficiaryBankAddress: "Endereço do Banco Beneficiário",
    ABA: "ABA (Número de Roteamento)",
    IBANnumber: "Número IBAN",
    StartingMonth: "Mês inicial",
    EndMonth: "Fim do mês",
    InvoiceInfo: "Informações da fatura",
  },
  UserSettings: {
    LanguageandLocation: "Idioma e Localização",
    Language: "Idioma",
    Selectyourpreferedlanguage: "Selecione seu idioma preferido",
    Location: "Localização",
    Selectyourlocation: "Selecione sua localização",
    NotificationSetting: "Configuração de Notificação",
    EmailNotification: "Notificação por E-mail",
    ServiceUpdates: "Atualizações de Serviço",
    CompanyNews: "Notícias da Empresa",
  },
  AddCredit: {
    Customizeyourplan: "Personalize o seu plano como precisar",
    Silver: "Prata",
    Gold: "Ouro",
    Enterpris: "Empresa",
    Credit: "Crédito",
    Remaining: "Restantes {0} pontos",
    Usermonth: "utilizador/mês",
    Useryear: "utilizador/ano",
    PaidMonthlyRenews:
      "Pago mensalmente, sem necessidade de renovação automática",
    PaidAnnuallyRenews:
      "Pago anualmente, sem necessidade de renovação automática",
    ForFullSupport: "para um suporte total às suas necessidades",
    Each: "cada",
    CreditsCharged:
      "Os créditos cobrados na sua conta nunca expirarão enquanto a sua conta permanecer ativa.",
    PaidMonthly: "pago mensalmente",
    PaidAnnually: "pago anualmente",
    BuyNow: "compre agora",
    ContactNow: "entre em contacto agora",
    SearchCompanies:
      "Pesquise empresas e obtenha acesso instantâneo aos dados da empresa que incluem",
    EverythinginSilverPackage: "Tudo no pacote Silver, mais",
    CreditsCanbeUsed:
      "Os créditos podem ser utilizados para mais serviços de dados, incluindo os seguintes",
    UnlimitedAdvancedSearch: "Pesquisa avançada ilimitada",
    ViewCompanyProfile: "Ver perfil da empresa",
    CompanyOwnershipStructure: "Estrutura de propriedade da empresa",
    CompanyFamilyTree: "Árvore genealógica da empresa",
    Companymanagement: "Gestão da empresa",
    CompanyContactsinfo: "Informação de contatos da empresa",
    BusinessActivities: "Atividades empresariais",
    IndustryBasics: "Noções básicas da indústria",
    ImportExportRecords: "Registos de importação e exportação",
    CompanyPublications: "Publicações da empresa",
    CompanyNews: "Notícias da empresa",
    DownloadOnlineReport: "Descarregue o relatório on-line",
    ManagementDetails: "Detalhes de gestão",
    ShareholderPenetration: "Penetração de acionistas (UBO)",
    Financialinfo: "Informações financeiras",
    FinancialAnalysis: "Análise financeira",
    CreditAssessment: "Avaliação de crédito",
    IndustryAnalysis: "Análise da indústria",
    MarketAnalysis: "Análise de mercado",
    SupplyChaininfo: "Informações da cadeia de abastecimento",
    CheckSanctions: "Verifique as sanções",
    CompanyComparison: "Comparação de empresas",
    DataExport: "Exportação de dados",
    MonitoringService: "Serviço de monitorização",
    DiscountForFreshUpdateReports:
      "Desconto para novos relatórios de atualização",
    SearchCompany: "Pesquisar empresa",
    SearchLeads: "Pesquisar leads",
    SearchTrade: "Pesquisar comércio",
    SearchPeople: "Pesquisar pessoas",
    SearchCountry: "Pesquisar país",
    SearchNews: "Pesquisar notícias",
    SearchSanction: "Sanção de pesquisa",
    DataServices: "Serviços de dados",
    APIPlans: "Planos API",
    VolumeDiscounts: "Descontos por volume",
    GroupAccountsWithMultipleUsers: "Contas de grupo com vários utilizadores",
    CustomizedPlans: "Planos Personalizados",
    FreshInvestigatedCreditReportsWorldwide:
      "Novos relatórios de crédito investigados em todo o mundo",
    BusinessMonitoringServices: "Serviços de monitorização de negócios",
    BusinessProcessVerificationServices:
      "Serviços de verificação de processos de negócio",
    VendorComplianceReports: "Relatórios de conformidade do fornecedor",
    MarketResearch: "Pesquisa de mercado",
    More: "Mais…",
    Contactus: "Contate-nos",
    PaymentMethod: "Método de pagamento",
    CreditCardNumber: "Número do cartão de crédito",
    EnterCardNumber: "Introduza o número do cartão",
    ExpirationDate: "Data de expiração",
    Fullnameoncard: "Nome completo no cartão",
    EnterFullname: "Introduza o nome completo",
    EnterProvinceState: "Inserir Província/Estado",
    CVCCode: "Código CVC",
    EnterCVCCode: "Introduza o código CVC",
    TotalPurchase: "Compra total",
    Agree1: "Ao clicar em “Submeter”, concorda com o ",
    Agree2: "Contrato de Serviços e Privacidade da CSI.",
    Submit: "Enviar",
    Month: "Mês",
    Year: "Ano",
    Country: "País",
    ProvinceState: "Província/Estado",
    Cancel: "Cancelar",
    IncorrectCreditCardNumberformat:
      "Formato incorreto do número do cartão de crédito",
    IncorrectExpMonthformat: "Formato do mês de vencimento incorreto",
    IncorrectExpYearformat: "Formato de ano de validade incorreto",
    IncorrectFullNameformat: "Formato de nome completo incorreto",
    IncorrectCountryformat: "Formato de país incorreto",
    IncorrectProvinceStateformat: "Formato de província/estado incorreto",
    IncorrectCVCCodeformat: "Formato de código CVC incorreto",
  },
  ReportIssues: {
    Whattypeoferrorsyouarereporting: "Que tipo de erro você está relatando?",
    Tellusmoreaboutyourproblems: "Conte-nos mais sobre seus problemas.",
    Wouldyouliketoprovideascreenshotorafileregardingyourproblem:
      "Gostaria de enviar uma captura de tela ou um arquivo relacionado ao seu problema?",
    Fillinyourcontactinformation: "Preencha suas informações de contato",
    FirstName: "Nome",
    LastName: "Sobrenome",
    PhoneNumber: "Número de telefone",
    Email: "E-mail",
    Edit: "Editar",
  },
  //Risk Scan
  RiskScan: {
    RiskScan: "Risk Scan",
    RiskScanInfo:
      "  é a sua plataforma completa para obter informações abrangentes sobre os riscos empresariais. Fornecemos análises detalhadas em todas as principais categorias de risco para proteger as suas decisões de negócio.",
    LegalRisk: "Risco legal",
    LegalRiskInfo: "Verifique a legitimidade da empresa.",
    OrganizationalRisk: "Risco organizacional",
    OrganizationalRiskInfo:
      "estabilidade da gestão, complexidade da estrutura empresarial e transparência da propriedade.",
    OperationalRisk: "Risco operacional",
    OperationalRiskInfo:
      "vulnerabilidades da cadeia de abastecimento, situação operacional e exposição geopolítica.",
    FinancialRisk: "Risco financeiro",
    FinancialPerformanceRiskInfo:
      "tendências de rendibilidade, problemas de liquidez e saúde do balanço.",
    CreditRisk: "Risco de crédito",
    CreditRiskInfo:
      "Solvência, histórico de pagamentos e probabilidade de incumprimento.",
    ComplianceRisk: "Risco de Conformidade",
    ComplianceRiskInfo:
      "Adesão a sanções, regulamentos de AML (Anti-Money Laundering - Combate ao Branqueamento de Capitais) e leis específicas do setor.",
    SustainabilityRisk: "Risco de Sustentabilidade",
    SustainabilityRiskInfo:
      "Fatores ESG (Ambientais, Sociais e de Governação) e impactos na reputação.",
    IndustryRisk: "Risco do setor",
    IndustryRiskInfo:
      "Avalia a estabilidade e as perspetivas de todo o setor de uma empresa.",
    LetBegin: "Vamos começar",
    AddcompaniesfromSearchResult:
      "Adicionar empresas a partir dos resultados da pesquisa",
    AddcompaniesfromMyDatabase: "Adicionar empresas da Minha Base de Dados",
    Addcompaniesbyuploadmyownlist:
      "Adicionar empresas carregando a minha própria lista",
    Uploadyourlistofcompanies:
      "Faça o upload da sua lista de empresas e o Risk Scan fornecerá atualizações instantâneas de dados para cada entidade. Com avaliações de risco abrangentes em oito categorias, o Risk Scan transforma a sua gestão de risco de reativa para proativa, tornando-a uma vantagem estratégica.",
    Select: "Selecionar",
    Upload: "Carregar",
    Cancel: "Cancelar",
    Confirm: "Confirmar",
    UploadFiles: "Enviar ficheiros",
    PleaseuploadyourfileinCVSformat:
      "Por favor, envie o seu ficheiro em formato xlsx.",
    Downloadxlsxtemplate: "Descarregue o modelo de xlsx",
    Xcompanieswereuploadedsucessfuly:
      "{0} empresas foram registadas com sucesso.",
    Xcompanieswereidentifiedsucessfuly:
      "Foram identificadas com sucesso {0} empresas.",
    Xcompanieswerenotmatched: "As empresas {0} não foram correspondidas.",
    Uploadingfilefailed:
      "O envio do ficheiro falhou. Por favor utilize o modelo e tente novamente.",
    Uploading: "Carregando",
    Uploadwithamaximumfilesizeof1M:
      "(É possível carregar um máximo de 100 entradas de dados de cada vez, com um tamanho máximo de ficheiro de 1 MB.)",
    Tryagain: "Tente novamente",
    Theuploadedonlyxlsx:
      "O ficheiro enviado deve estar apenas no formato xls/xlsx",
    Scanning: "Digitalização",
    RiskScanning: "Análise de Riscos",
    Youhaveselectedatotalof: "Selecionou ",
    Tostartriskscanning:
      'empresas. Clique em "Confirmar" para iniciar a verificação.',
    Datascanningisinprogress: "A digitalização dos dados está em curso...",
    LastUpdate: "Última atualização",
    Selectdate: "Selecione a data",
    UpdateStatus: "Atualizar estado",
    ClearAll: "Limpar tudo",
    ALL: "Todos",
    Updated: "Atualizada",
    Notupdated: "Não atualizado",
    HistoricalData: "Dados históricos",
    Selectrisklevel: "Selecione o nível de risco",
    Low: "Baixo",
    Average: "Média",
    Caution: "Cuidado",
    NotRated: "Sem classificação",
    Reselect: "Selecionar novamente",
    HistoricalRecords: "Registos históricos",
    DownloadReport: "Baixar relatório",
    SearchLeads: "Prospectos de Busca",
    CompanyName: "Nome da empresa",
    CompanyID: "ID da empresa",
    CompanyType: "Tipo de empresa",
    RegistrationDate: "Data de inscrição",
    RegistrationStatus: "Estado do registro",
    Listed: "cotada na bolsa de valores",
    LegalStatus: "Situação Jurídica",
    NoofShareholders: "Número de acionistas",
    ShareholdingLayers: "Níveis de acionistas",
    NoofCorporateShareholders: "Número de acionistas empresariais",
    NoofNatualPersonShareholders: "Número de acionistas pessoas singulares",
    RelatedCompanies: "Empresas relacionadas",
    OrganizationalStatus: "Situação organizacional",
    OperatingAddress: "Endereço de operação",
    IndustryCode: "Código da Indústria",
    BusinessActivities: "Atividades comerciais",
    NoofEmployees: "Número de colaboradores",
    Management: "Gestão",
    CurrentOperations: "Operações atuais",
    Revenue: "faturamento",
    Assests: "Ativas",
    ProfitLoss: "Lucro/Prejuízo",
    Liquidity: "Liquidez",
    Growth: "crescimento",
    Performance: "Desempenho operacional",
    CreditRating: "avaliação de crédito",
    CreditScore: "Pontuação de crédito",
    PausibilityofDefault: "Pausibilidade do Incumprimento (PD)",
    SolvencyIndex: "Índice de Solvência",
    DebtCollection: "cobrança de dívidas",
    CreditOpinion: "Parecer de Crédito",
    CompanySanction: "de sanções corporativas",
    ProductSanction: "Sanção de produto",
    ExportControl: "Controlo de Exportação",
    AntiCorruptionAntiBribery: "Anticorrupção e Anti-suborno",
    Litigations: "Litígios",
    NegativeNews: "Notícias negativas",
    ESGScore: "Pontuação ESG",
    YearsinBusiness: "Anos de experiência no setor",
    Competitiveness: "Competitividade",
    WorkingCapital: "Risco de mercado",
    FinancialStructure: "Índice da Cadeia de Abastecimento",
    Industrystatus: "Situação do setor",
    IndustryOutlook: "Perspectivas do setor",
    NoofCompanies: "Número de empresas",
    IndustryRanking: "Classificação do setor",
    IndustryConcentration: "% do PIB da indústria",
    IndustryCompetitiveness: "Competitividade do setor",
    IndustryDevelopment: "Desenvolvimento da Indústria",
    Legal: "Legal",
    Organizational: "Organizacional",
    Operational: "Operacional",
    Financial: "Financeira",
    Credit: "Crédito",
    Compliance: "Conformidade",
    Sustainability: "Sustentabilidade",
    Industry: "Indústria",
    ScanDate: "Data da digitalização",
    Updating: "Atualizando",
    ScanHistoricalData: "Analisar dados históricos",
    StartDate: "Data de Início",
    EndDate: "Data de Término",
    Download: "Baixar",
    Entercompanyname: "Introduza o nome da empresa",
  },
  //Data Management
  DataManagement: {
    DataManagement: "gestão de dados",
    AllCompanies: "Todas as empresas",
    CompaniesViewed: "Empresas visualizadas",
    CompaniesCollected: "Empresas Coletadas",
    CompaniesUploaded: "Empresas Carregadas",
    MyPortfolio: "O Meu Portfólio",
    Date: "Data",
    CompanyName: "Nome da empresa",
    Country: "País",
    CompanyType: "Tipo de empresa",
    CompanyStatus: "Situação da empresa",
    DQI: "DQI",
    Download: "Transferir",
    Addcompanies: "Adicionar empresas",
    Filter: "Filtrar",
    Selectcountry: "Selecione o país",
    Selectindustry: "Selecione o setor",
    Selectcompanytype: "Selecione o tipo de empresa",
    Selectcompanysize: "Selecione o tamanho da empresa",
    Selectcompanystatus: "Selecione o estado da empresa",
    Selectlistedcompanies: "Selecione as empresas listadas",
    Selectcompanyyearsinbusiness: "Selecione o tempo de atividade da empresa.",
    Industry: "Indústria",
    CompanySize: "Tamanho da empresa",
    Listed: "listadas",
    CompanyAge: "Idade da empresa",
    SelectYear: "Selecione o ano",
    SelectQuarter: "Selecione o trimestre",
    SelectMonth: "Selecione o mês",
    Reset: "Reiniciar",
    Search: "Pesquisa",
    MyDatabase: "O meu banco de dados",
    Locations: "Localizações",
    YearsinBusiness: "Anos de experiência no setor",
    CompanyDQI: "DQI",
    RiskScan: "Análise de Risco",
    CreditAssessment: "Avaliação de Crédito",
    Uptodate: "Atualizado",
    Average: "Média",
    Insufficient: "Insuficiente",
    Good: "Boa",
    Caution: "Cuidado",
    Unknown: "Desconhecida",
    CompanyTag: "Etiqueta da empresa",
    Remove: "Remover",
    Uploaded: "Enviado",
    Identified: "Identificada",
    Notmatched: "Não corresponde a nenhuma das opções",
    UploadCompanies: "Carregar empresas",
    Match: "Correspondência",
    Delete: "Eliminar",
    OnlineMatching: "Combinação online",
    Identifythecompanywithmanualcheck:
      "Identifique a empresa através de verificação manual.",
    Identifyacompanymanually: "Identificar uma empresa manualmente",
    Pleaseprovideanyrelevantinformation:
      "Forneça qualquer informação relevante que possa melhorar os resultados da pesquisa. O nosso analista de dados irá encontrar a empresa mais adequada para si.",
    RegistrationID: "ID da empresa",
    StateProvince: "Estado/Província",
    Address: "Morada",
    Otherinformation: "Outras informações",
    Submit: "Submeter",
    Cancel: "Cancelar",
    Confirm: "Confirmar",
    EnterRegistrationID: "Introduza o ID de registo",
    EnterAddress: "Insira o endereço",
    EnterInformation: "Insira as informações",
    User: "Usuária",
    Task: "Tarefa",
    NoofCompanies: "Número de empresas",
    Entercompanyname: "Introduza o nome da empresa",
    SaveYourPortfolio: "Guarde o seu portfólio",
    PortfolioName: "Nome do Portfólio",
    Notes: "Notas",
    Edit: "Editar",
    EnterPortfolioName: "Introduza o nome do portfólio",
    EnterUserName: "Introduza o usuário",
    SelectTaskName: "Selecione a tarefa",
    EnterNotes: "Insira observações",
    StartingMonth: "Mês inicial",
    EndMonth: "Fim do mês",
  },
  Relationship: {
    SearchRelationship: "Relação de Busca",
    SearchRelationshipInfo:
      " é o nosso principal serviço de dados, concebido para iluminar todo o ecossistema corporativo de qualquer empresa. A plataforma oferece uma visão abrangente de 360 ​​graus da sua empresa, revelando:",
    UltimateOwnershipControl: "Propriedade e Controlo Final",
    UltimateOwnershipControlInfo:
      "Desvende a cadeia de propriedade através do rastreio de camadas complexas para identificar os beneficiários finais e todos os acionistas.",
    InvestmentParticipation: "Investimento e Participação",
    InvestmentParticipationInfo:
      "Descubra todas as empresas em que a empresa investiu, fez parcerias ou participou, revelando direções estratégicas e alianças ocultas.",
    SupplyChainNetwork: "Supply Chain Network",
    SupplyChainNetworkInfo:
      "Mapear o espectro das relações comerciais, identificando todos os fornecedores e clientes possíveis para compreender todo o fluxo do comércio.",
    Ourplatformempowers:
      "A nossa plataforma capacita as suas decisões críticas, ajudando-o a descobrir oportunidades, a simplificar a conformidade e a mitigar riscos. Com o Search Relationship, a transparência está à distância de uma pesquisa.",
    LetsBegin: "Vamos começar",
    CompanyName: "Nome da empresa",
    Country: "país",
    Industry: "Indústria",
    CompanyType: "Tipo de empresa",
    CompanySize: "Tamanho da empresa",
    CompanyStatus: "Situação da empresa",
    ListingInfo: "Informação de listagem",
    YearsinBusiness: "Anos de operação",
    IncDate: "Data de Inscrição",
    HSCode: "Código HS",
    Product: "Produto",
    HsCodeProduct: "Código HS / Produto",
    ImportExport: "Importação e Exportação",
    Entercompanyname: "Introduza o nome da empresa",
    SelectHsCodeProduct: "Selecione o código HS/produto",
    Background: "Histórico",
    CompanySnapshot: "Perfil da Empresa",
    Address: "Morada",
    CountyCity: "Concelho/Cidade",
    ProvinceState: "Província/Estado",
    CountryRegion: "País/Região",
    ZipCode: "CEP",
    RegName: "Nome Registado",
    Website: "Site",
    Email: "E-mail",
    Phone: "Telefone",
    LastUpdate: "Última atualização",
    DataSource: "Fonte de dados",
    CompanyProfile: "perfil de companhia",
    CoNativeName: "Nome nativo da empresa",
    CompanyID: "ID da empresa",
    VATNumber: "Número de IVA",
    StockExchangeNumber: "Número da Bolsa de Valores",
    Listed: "Registada",
    RegistrationDate: "Data de inscrição",
    LegalForm: "Forma Legal",
    LegalStatus: "Situação Jurídica",
    Jurisdiction: "Jurisdição",
    RegisteredAddress: "Endereço Registado",
    OperatingAddress: "Endereço de operação",
    Ownership: "Propriedade",
    Investments: "Investimentos",
    PossibleVendors: "Possíveis fornecedores",
    PossibleClients: "Possíveis clientes",
    UItimateBeneficiaryOwner: "Proprietário Beneficiário Final (UBO)",
    ControllingShareholder: "Acionista controlador",
    Participations: "Participações",
    ShareholderLevel: "Camadas de participação acionista",
    PartiesInvolved: "Partes envolvidas",
    RelatedCompanies: "Empresas relacionadas",
    CompanyShareholders: "Acionistas da Sociedade",
    CoShareholders: "Acionistas da Sociedade",
    NGOShareholders: "Acionistas de ONG",
    NaturalPersonShareholders: "Acionista Pessoa Singular",
    SubjectsInvestments: "Investimentos do sujeito",
    CorporateShareholders: "Acionistas Corporativos",
    Name: "Nome",
    Location: "Localização",
    Type: "Tipo",
    Shares: "Participação acionista (%)",
    Relations: "Relações",
    TotalEntities: "Total de entidades",
    Entities: "Entidades",
    Subsidiaries: "Subsidiárias",
    Countries: "Países",
    Branches: "Filiais",
    Relationship: "Relação",
    RelationType: "Tipo de relacionamento",
    RelationLevel: "Nível de relacionamento",
    Management: "administração",
    ContactInfo: "Informações de contato",
    Position: "Cargo",
    Department: "Departamento",
    ShareholderorNot: "Acionista ou não",
    Pleaseentername: "Por favor insira o nome",
    SupplyChain: "Cadeia de mantimentos",
    PossibleClients: "Possíveis clientes",
    PossibleSuppliers: "Possíveis fornecedores",
    Banking: "Bancária",
    TotalSales: "Vendas totais",
    TotalPurchasing: "Compras totais",
    ActivePlayers: "Jogadores ativos",
    MainProductsServices: "Principais produtos/serviços",
    TotalTradingVolume: "Volume total de negociação",
    TransactionTotal: "Transação/Total (%)",
    RecentTradeDate: "Data da última transação",
    IndustryCode: "Código do setor",
    TradeRelatedCompanies: "Empresas relacionadas com a transação",
    TradeRelatedProductTOP10:
      "Top 10 dos produtos relacionados com a transação",
    UBO: "Proprietário Beneficiário Final",
    Numberofshareholderenterprises: "Número de acionistas",
    CurrentLevel: "Nível atual",
    SharesonSubjectCo: "Ações da empresa em causa.",
    EnterCurrentLevel: "Introduza o nível atual",
    EnterCountry: "Introduza o país",
    DirectShareholdingPercentage: "Índice de participação acionista direta",
    TotalOwnershipPercentage: "Índice de participação acionista total",
    InvestmentHoldingLevel: "Nível de participação no investimento",
  },
  SearchSanctions: {
    CountryISO: "ISO do país",
    Currency: "Moeda",
    Language: "Idioma",
    SanctionOtherCountries: "Sancionar outros países",
    SanctionedbyOtherCountries: "Sancionado por outros países",
    CountriesTerritories: "Países/Territórios",
    Selectcountryterritory: "Selecione o país/território",
    Noofcountriessanctionedby: "Nº de países sancionados por {0}",
    Noofcountriesthatsanctioned: "Nº de países que sancionaram {0}",
    Noofsanctionedcompanies: "Nº de empresas sancionadas",
    Noofsanctionedpersonnel: "Nº de pessoal sancionado",
    SanctionOverview: "Visão geral das sanções",
    NoofSanctions: "Nº de sanções",
    TypesofSanctions: "Tipos de sanções",
    SourceofSanctions: "Fonte de Sanções",
    Details: "Detalhes",
    Advisories: "Avisos",
    LawEnforcement: "Autoridades Policiais",
    Warnings: "Alertas",
    FinancialSanctions: "Sanções Financeiras",
    ExclusionList: "Lista de Exclusão",
    TradeRestrictions: "Restrições Comerciais",
    VisaTravelBan: "Proibição de Vistos/Viagens",
    WarCrimes: "Crimes de Guerra",
    EnforcementOrders: "Ordens de Execução",
    Others: "Outros",
    ClearAll: "Limpar tudo",
    Provider: "Provedor",
    Description: "Descrição",
    Sanctions: "Sanções",
    SanctionID: "ID da sanção",
    SelectsanctionID: "Selecione o ID da sanção",
    SanctionedType: "Tipo Sancionado",
    SelectSanctionedType: "Selecione o tipo de sanção",
    CompanyPersonnel: "Empresa/Pessoal",
    Selectcompanypersonnel: "Selecione empresa/pessoal",
    SanctionCategory: "Categoria de Sanção",
    Selectsanctioncategory: "Selecione a categoria de sanção",
    Reference: "Referência",
    Selectreference: "Selecione a referência",
    SanctionSource: "Fonte de Sanção",
    Selectsanctionsource: "Selecione a fonte da sanção",
    Status: "Estado",
    Selectstatus: "Selecione o estado",
    CountryofSource: "País de origem",
    Name: "Nome",
    SanctionedCountries: "Países Sancionados",
    ProviderCode: "Código do Provedor",
    RecordSource: "Fonte de registo",
    From: "De",
    To: "Para",
    CompanyName: "Nome da empresa",
    SelectCompanyName: "Selecione o nome da empresa",
    Country: "País",
    SelectCountry: "Selecione o país",
    SelectRecordSource: "Selecione a fonte do registo",
    RegName: "Nome registado",
    Address: "Endereço",
    Website: "Site",
    CountyCity: "Condado/Cidade",
    Email: "E-mail",
    ProvinceState: "Província/Estado",
    Tel: "Tel",
    CountryRegion: "País/Região",
    LastUpdate: "Última Atualização",
    ZipCode: "CEP",
    DataSource: "Fonte de Dados",
    SanctionInfo: "Informações sobre sanções",
    SanctionRelated: "Relacionado com Sanções",
    OwnershipRelatedCompanies: "Propriedade e empresas relacionadas",
    OfficialSanctionList: "Lista Oficial de Sanções",
    SanctionType: "Tipo de Sanção",
    Type: "Tipo",
    Relations: "Relações",
    ProfileNotes: "Observações do Perfil",
    Sources: "Fontes",
    DescriptionofReferenceName: "Descrição da Referência",
    DOB: "Data de nascimento",
    Gender: "Gênero",
    SearchPersonName: "Pesquisar nome da pessoa",
    SelectDOB: "Selecionar data de nascimento",
    Male: "Masculino",
    Female: "Feminino",
    All: "Todos",
    FirstName: "Primeiro nome",
    MiddleName: "Nome do meio",
    LastName: "Sobrenome",
    PreviousName: "Nome anterior",
    PlaceofBirth: "Local de nascimento",
    Citizenship: "Cidadania",
    Residence: "Residência",
    Juristiction: "Jurisdição",
    History: "História",
    Category: "Categoria",
    Title: "Título",
    SanctionRecord: "Registo de Sanções",
    Relationship: "Relacionamento",
    HSCode: "Código HS",
    ProductName: "Nome do produto",
    SanctionedCountryRegion: "País/região sancionado",
    SelectSanctionedCountryRegion: "Selecione o país/região sancionado",
    SelectHSCode: "Selecione o código HS",
    SelectProductName: "Selecione o nome do produto",
    Selectsanctiontype: "Selecione o tipo de sanção",
  },
  SearchTrade: {
    LastUpdate: "Última atualização",
    ProductCode: "Código do produto",
    ProductDescription: "Descrição do produto",
    Sanctions: "Sanções",
    TotalImports: "Importações totais",
    TotalExports: "Exportações totais",
    TotalImportWeight: "Peso total de importação",
    TotalExportWeight: "Peso total de exportação",
    NumberofSuppliers: "Número de Fornecedores",
    NumberofBuyers: "Número de compradores",
    NumberofOriginCountries: "Número de países de origem",
    NumberofDestinationCountries: "Número de países de destino",
    TradeMap: "Mapa Comercial",
    Imports: "Importações",
    Exports: "Exportações",
    Reset: "Reiniciar",
    Product: "Produto",
    Destination: "Destino",
    Origin: "Origem",
    NoData: "Sem dados",
    Date: "Data",
    TotalTransactions: "Total de transações",
    Transactions: "Transações",
    TradeRanking: "Classificação comercial",
    Top5Ranking: "Ranking dos 5 melhores",
    Growth: "Crescimento",
    Decline: "Declínio",
    TradeTrends: "Tendências comerciais",
    TradeVolume: "Volume de Comércio",
    MonthonMonthRatio: "Proporção mês a mês",
    Suppliers: "Fornecedores",
    Buyers: "Compradores",
    Startdate: "Data de Início",
    Enddate: "Data de Término",
    SelectCountry: "Selecione um país",
    SelectCompany: "Selecione a empresa",
    ClearAll: "Limpar tudo",
    TransactionDate: "Data da Transação",
    SelectTransactionDate: "Selecione a data da transação",
    Company: "Empresa",
    CompanyName: "Nome da empresa",
    Country: "País",
    Industry: "Setor",
    SelectIndustry: "Selecione a indústria",
    SupplierOverview: "Visão Geral do Fornecedor",
    BuyerOverview: "Visão Geral do Comprador",
    CompanyID: "ID da Empresa",
    ISIC: "ISIC",
    ISICDescription: "Descrição do ISIC",
    TotalTradeAnnual: "Total do Comércio (Anual)",
    TotalTradePastsixmonth: "Total de Comércio (Últimos 6 meses)",
    ContactInformation: "Informações de contacto",
    ShippingOverview: "Visão geral do transporte marítimo",
    TradeHistoryandTrends: "Histórico e tendências comerciais",
    SupplyChainList: "Lista da Cadeia de Abastecimento",
    RegistrationDate: "Data de Registro",
    Profit: "Lucro",
    NoofShareholders: "Nº de Acionistas",
    TotalAssets: "Ativo Total",
    IndustryCode: "Código do Setor",
    CreditRating: "Classificação de Crédito",
    NoofEmployees: "Número de Funcionários",
    CreditScore: "Score de Crédito",
    Listed: "Listada",
    ESGRating: "Classificação ESG",
    Revenue: "Receita",
    DQI: "DQI",
    MoreCoDetails: "Mais detalhes da empresa",
    CoNews: "Notícias da empresa",
    MoreCoNews: "Mais notícias da empresa",
    IndustryMean: "Média do setor",
    TargetSubjectRevenue: "Receita da meta",
    PossibleBuyers: "Possíveis Compradores",
    PossibleSuppliers: "Possíveis Fornecedores",
    ShowAll: "Mostrar tudo",
    TotalExportsAnnual: "Total das Exportações (Anual)",
    TotalImportsAnnual: "Total das Importações (Anual)",
    ExportAmount: "Valor das Exportações",
    ImportAmount: "Valor das Importações",
    ShipmentDetail: "Detalhes do Envio",
    Entersuppliername: "Nome do Fornecedor",
    Enterbuyername: "Nome do Comprador",
    SupplierName: "Nome do Fornecedor",
    BuyerName: "Nome do Comprador",
    TotalAmount: "Valor Total",
    Details: "Detalhes",
    WaybillDetails: "Detalhes da guia de remessa",
    ListofOrigins: "‌Lista Das Origens‌",
    ListofDestinations: "‌Lista Das Destinos‌",
    ISO: "‌ISO‌",
    Currency: "‌Moeda‌",
    Language: "Idioma",
    Address: "Endereço",
    OverviewofSupplyChainInformation:"Visão geral das informações da cadeia de abastecimento",
    OriginInformationOverview: "Visão geral das informações de origem",
    DestinationInformationOverview: "Visão geral das informações de destino",
    ImportCountries: "Países Importadores",
    ExportCountries: "Países Exportadores",
    ImportCompanyTop: "Informações gerais sobre os esquemas de treino",
    ExportCompanyTop: "Informações sobre informações sobre o oorsprong",
    SanctionType: "‌Tipo de sanção‌",
    SelectSanctionType: "‌Selecionar tipo de sanção‌",
    SanctionedCountryRegion: "‌País/Região sancionado(a)‌",
    SelectSanctionedCountryRegion: "‌Selecionar país/Região sancionado(a)‌",
    HSCode: "‌Código SH‌",
    SanctionedProductsOverview: "‌Visão geral dos produtos sancionados‌",
    Searchmoresanctiononothercompanies:
      "‌Pesquisar mais sanções em outras empresas‌",
    SimilarProducts: "Produtos semelhantes",
    Numberofsimilarproducts: "Número de produtos similares",
    TopImportCountries: "5 principais países importadores",
    TopExportCountries: "5 principais países exportadores",
    PleaseSelect: "Por favor selecione",
    EnterHSCodeProductName: "Introduza o código HS e o nome do produto",
    ImportProducts: "Produtos de Importação",
    ExportProducts: "Produtos de Exportação",
    NumberofOrigin: "Número de Países de Origem",
    NumberofDestination: "Número de Países de Destino",
    NumberofImportProducts: "Número de Produtos Importados",
    NumberofExportProducts: "Número de Produtos Exportados",
    ProductName: "Nome do produto",
    SelectProductName: "Selecione o nome do produto",
    TopExportProducts: "Os 5 principais produtos de exportação",
    TopImportProducts: "Os 5 principais produtos de importação",
    ExportProductOverview: "Visão geral dos produtos de exportação",
    ImportProductOverview: "Visão geral dos produtos de importação",
    CompanyCompetitiveness: "Competitividade da Empresa",
    GlobalMarketShare: "Participação no Mercado Global",
    RegionalMarketShare: "Participação no Mercado Regional",
    BusinessGrowthGlobalMarket: "Crescimento do Negócio (Mercado Global)",
    BusinessGrowthRegionalMarket: "Crescimento do Negócio (Mercado Regional)",
    CreditAssessment: "Avaliação de Crédito",
    LocalCreditScore: "Pontuação de crédito local",
    SolvencyIndex: "Índice de Solvência",
    ProbabilityofDefault: "Probabilidade de incumprimento",
    RiskIndicator: "Indicador de Risco",
    CreditLine: "Linha de Crédito",
    ReturnonEquity: "RRetorno sobre o Patrimônio Líquido",
    ProfitMargin: "Margem de Lucro",
    RelatedCreditAssessment: "Avaliação de Crédito Relacionada",
    HighRisk: "Alto Risco",
    Medium: "Risco Médio",
    Moderate: "Risco Moderado",
    Average: "Risco Médio",
    LowerThanAvg: "Risco Abaixo da Média",
    LowRisk: "Risco Baixo",
    CreditOpinion: "Parecer de Crédito",
    ComparisonofSimilarProducts: "Comparação de Produtos Similares",
    AddProduct: "Adicionar produto",
  },

  TradeByCountry: {
    // ImpExpCountries: "",
    // ImpExpCompanies: "",
    // ImpExpProducts: "",
    // Assessment: "",
    TotalImportAmount: "Valor total das importações",
    GlobalImportShare: "Participação global das importações",
    ImportGrowth: "Crescimento das importações",
    TotalExportAmount: "Valor total das exportações",
    GlobalExportShare: "Participação global das exportações",
    ExportGrowth: "Crescimento das exportações",
    TradeBalance: "Balança comercial",
    CountryData: "Dados do País",
    GDP: "PIB",
    GDPPPP: "PIB (PPC)",
    ExportsofGoods: "Exportações de Mercadorias",
    ExportsofServices: "Exportações de Serviços",
    ImportsofGoods: "Importações de Mercadorias",
    ImportsofServices: "Importações de Serviços",
    CPI: "IPC",
    Population: "População",
    ContainerPortThroughput: "Movimentação de Contentores nos Portos",
    DistributionofImportExportCountries:
      "Distribuição dos Países Importadores e Exportadores",
    Top5Ranking: "Ranking dos 5 Principais",
    Importers: "Importadores",
    Exporters: "Exportadores",
    ImportCountries: "Países Importadores",
    ExportCountries: "Países Exportadores",
    ImportProducts: "Produtos Importados",
    ExportProducts: "Produtos Exportados",
    CountryImportExportOverview:
      "Visão Geral das Importações e Exportações por País",
    Year: "Ano",
    Amount: "Valor",
    Balance: "Saldo",
    CountryTradeDataComparison: "Comparação de Dados Comerciais entre Países",
    Comparison: "Comparação",
    AddSample: "Adicionar Amostra",
    AddCriteria: "Adicionar Critérios",
    ImportCountry: "País de Importação",
    Selectimportcountries: "Selecione os países de importação",
    ExportCountry: "País de Exportação",
    Selectexportcountries: "Selecione os países de exportação",
    EnterHSCodeProductName: "Introduza o nome do produto ou o código HS",
    // Afterselectingthecriteria: "",
    ShowResult: "Mostrar Resultado",
    ListofTradeCompanies: "Lista de empresas comerciais",
    TotalCompanies: "Total de empresas",
    Top5Products: "5 principais produtos",
    ListofExportProducts: "Lista de Produtos de Exportação",
    ListofImportProducts: "Lista de Produtos de Importação",
    Top5ExportCountries: "5 Principais Países Exportadores",
    Top5ImportCountries: "5 Principais Países Importadores",
    HSDescription: "Descrição SH",
    HSCode: "‌Código SH‌",
    TradeCompetitivenessIndex: "Índice de Competitividade Comercial",
    TotalTradeAmount: "Valor Total das Trocas Comerciais",
    NetTradeBalance: "Balança Comercial Líquida",
    TradeGap: "Défice Comercial",
    TradeGoodsExports: "Exportações de Mercadorias",
    TradeGoodsImports: "Importações de Mercadorias",
    TradeServicesExports: "Exportações de Serviços",
    TradeServicesImports: "Importações de Serviços",
    CompositePMI: "PMI Composto",
    ServicesPMI: "PMI de Serviços",
    LegalEnvironment: "Ambiente Jurídico",
    CorporateTaxRate: "Taxa do Imposto sobre o Rendimento das Empresas",
    PersonalIncomeTaxRate:
      "Taxa do Imposto sobre o Rendimento das Pessoas Singulares",
    SalesTaxRate: "Taxa do Imposto sobre Vendas",
    BusinessConfidenceIndex: "Índice de Confiança Empresarial",
    CountryRating: "Classificação do País",
    CompetitivenessIndex: "Índice de Competitividade",
    CompetitivenessRank: "Classificação de Competitividade",
    EaseofDoingBusiness: "Facilidade de Fazer Negócios",
    BusinessConfidence: "Confiança Empresarial",
    ConsumerConfidence: "Confiança do Consumidor",
    BusinessClimateAssessment: "Avaliação do Clima Empresarial",
    SP: "S&P",
    Moodys: "Moody's",
    Fitch: "Fitch",
    DBRS: "DBRS",
    Allianz: "Allianz",
    Coface: "Coface",
    Atradius: "Atradius",
    OECD: "OCDE",
    Productivecapacitiesindex: "Índice de Capacidade Produtiva",
    PleaseSelect: "Por favor selecione",
    transactionvolume: "Volume de transações",
    Growth: "Crescimento",
    Decline: "Declínio",
    SelectCountry: "Selecione o país",
    TradeVolume: "Volume de Comércio",
    Youcanonlyaddupto5datacomparisonitems:
      "Pode adicionar até 5 itens de comparação de dados.",
    // DataComparisonActive: "",
    // DataComparisonBlack: "",
    ProductName: "Nome do produto",
    Product: "Produto",
    EnterproductnameorHSCode: "Introduza o nome do produto ou o código HS",
    Date: "Data",
    OverviewofAnalysisContent: "Visão geral do conteúdo da análise",
    Afterselectingthecriteria: "Após selecionar os critérios, ",
    thecomparisonresultwillbedisplayed:
      "será apresentado o resultado da comparação.",
    ImportExport: "Importação e Exportação",
    All: "Todos",
    Company: "Companhia",
    SelectCompanyName: "Selecione o nome da empresa",
    SelectProductName: "Selecione o nome do produto",
    CompanyID: "ID da Empresa",
    CO: " C/O",
    ISIC: "ISIC",
    ISICDescription: "Descrição do ISIC",
    Top5ExportProducts: "5 Principais Produtos Importados",
    Top5ImportProducts: "5 Principais Produtos Exportados",
    ContactInformation: "Informações de contacto",
    SearchTrade: "Pesquisar comércio",
    NumberofImportProducts: "Número de Produtos Importados",
    NumberofExportProducts: "Número de Produtos Exportados",
    TransactionYear: "Ano da Transação",
    SelectTransactionYear: "Selecione o Ano da Transação",
    Totalnumberofimportedproducts: "Total de produtos importados",
    Totalnumberofexportedproducts: "Total de produtos exportados",
    Updateyear: "Ano de atualização",
    // TotalTrade: "",
    ISO: "ISO",
    Currency: "Moeda",
    Language: "Idioma",
  },
  ...ptLocale,
};

export default pt;
